import { apiCall } from './gqlClient';

const GETSECTIONS_QUERY = `
  query getSections($productId: String!) {
    getSections(productId: $productId)
    {
      id
			name
			orderIndex
			productId
			videoCourseId
			numberOfFiles
			availableAfter
			periodType
			userEmail
			userLanguage
			videoName
      ...fragments
    }
  }`;

export const getSectionsApiCall = async ({productId}, fragments = null) => apiCall({ query: GETSECTIONS_QUERY, variables: {productId}, fragments });

const SAVESECTION_QUERY = `
  mutation saveSection($name: String!, $productId: String, $id: String, $availableAfter: Int, $periodType: String) {
    saveSection(name: $name, productId: $productId, id: $id, availableAfter: $availableAfter, periodType: $periodType)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const saveSectionApiCall = async ({name, productId, id, availableAfter, periodType}, fragments = null) => apiCall({ query: SAVESECTION_QUERY, variables: {name, productId, id, availableAfter, periodType}, fragments });

const DELETESECTION_QUERY = `
  mutation deleteSection($id: String!) {
    deleteSection(id: $id)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const deleteSectionApiCall = async ({id}, fragments = null) => apiCall({ query: DELETESECTION_QUERY, variables: {id}, fragments });

const ADDFILEINTOSECTION_QUERY = `
  mutation addFileIntoSection($sectionId: String!, $fileId: String!, $intro: Boolean!, $free: Boolean!) {
    addFileIntoSection(sectionId: $sectionId, fileId: $fileId, intro: $intro, free: $free)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const addFileIntoSectionApiCall = async ({sectionId, fileId, intro, free}, fragments = null) => apiCall({ query: ADDFILEINTOSECTION_QUERY, variables: {sectionId, fileId, intro, free}, fragments });

const REMOVEFILEFROMSECTION_QUERY = `
  mutation removeFileFromSection($sectionId: String!, $fileId: String!) {
    removeFileFromSection(sectionId: $sectionId, fileId: $fileId)
  }`;

export const removeFileFromSectionApiCall = async ({sectionId, fileId}, ) => apiCall({ query: REMOVEFILEFROMSECTION_QUERY, variables: {sectionId, fileId}});

const REORDERSECTIONS_QUERY = `
  mutation reorderSections($videoCourseId: String!, $oldPosition: Int!, $newPosition: Int!) {
    reorderSections(videoCourseId: $videoCourseId, oldPosition: $oldPosition, newPosition: $newPosition)
  }`;

export const reorderSectionsApiCall = async ({videoCourseId, oldPosition, newPosition}, ) => apiCall({ query: REORDERSECTIONS_QUERY, variables: {videoCourseId, oldPosition, newPosition}});

const DUPLICATESECTION_QUERY = `
  mutation duplicateSection($id: String!, $videoId: String!) {
    duplicateSection(id: $id, videoId: $videoId)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const duplicateSectionApiCall = async ({id, videoId}, fragments = null) => apiCall({ query: DUPLICATESECTION_QUERY, variables: {id, videoId}, fragments });
